'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n    width: 22px;\n    height: 22px;\n    position : absolute;\n    cursor: pointer;\n    bottom: 3px;\n    margin: auto;\n    right: 10px;\n'], ['\n    width: 22px;\n    height: 22px;\n    position : absolute;\n    cursor: pointer;\n    bottom: 3px;\n    margin: auto;\n    right: 10px;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Img = _styledComponents2.default.img(_templateObject);

var Icon = function Icon(props) {
  return _react2.default.createElement(Img, _extends({}, props, {
    className: props.className,
    src: props.icon
  }));
};
Icon.propTypes = {
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  icon: _propTypes2.default.string.isRequired
};
exports.default = Icon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-modern-datepicker/build/elements/Icon.js
// module id = 478
// module chunks = 0